import { MCs } from 'src/components/mc-list/mcs/MCs'
import React from 'react'

export const MCsPage = () => {
  return (
    <div data-testid="dashboard-master-contractors-page">
      <MCs />
    </div>
  )
}
